import { FunctionComponent, ChangeEventHandler, FocusEventHandler } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/ACHForm.scss';

import Text from '../inputs/Text';

type Props = {
    value?: string;
    error?: string;
    autoFocus?: boolean;
    isBlurred?: boolean;
    disabled?: boolean;
    onChange: ChangeEventHandler;
    onBlur?: FocusEventHandler;
};

const messages = defineMessages({
    placeholder: {
        id: 'ACHForm.BusinessName.placeholder',
        defaultMessage: 'Business Name on Account*',
    },
});

const BusinessName: FunctionComponent<Props> = ({
    value = '',
    autoFocus = false,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => null,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="businessNameOnAccount"
            dataTn="billing-achBusinessName"
            value={value}
            wrapperClass={styles.full}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="ach-business-name"
            autoFocus={autoFocus}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

export default BusinessName;
